import { useMemo } from 'react';
import { useCookies } from 'react-cookie';

const TOKEN_NAME = 'authToken';
export const useAuthToken = () => {
    const [cookies, setCookie, removeCookie] = useCookies([TOKEN_NAME]);
    const setAuthToken = useMemo(() => (authToken) => setCookie(TOKEN_NAME, authToken), [setCookie]);
    const removeAuthToken = useMemo(() => () => removeCookie(TOKEN_NAME), [removeCookie]);
    const value = useMemo(
        () => ({ authToken: cookies[TOKEN_NAME], setAuthToken, removeAuthToken }),
        [cookies, removeAuthToken, setAuthToken],
    );
    return value;
};
